import { exportDesignerTranslations, exportDesignerTranslationTemplate } from "../../designer-translation-actions";
import { getSdInstance } from "../helpers";
import type { ToolHandlerGroup } from "../types";

export const fileTools: ToolHandlerGroup = {
  async: {
    ui_common_export_translations: async (input) => {
      return exportDesignerTranslations(getSdInstance(), {
        language: input.language,
        filter: input.filter
      });
    },

    ui_common_export_excel_template: async (input) => {
      return exportDesignerTranslationTemplate(getSdInstance(), {
        language: input.language
      });
    }
  }
};
